import React from 'react'
import dayjs from 'dayjs'
import { Box, Theme } from '@mui/material'
import { AppointmentStatus } from '../../../../../models/graphqlTypes'
import { Appointment, Referral, Survey } from '../../types/treatments.types'

interface DayBackground {
  theme: Theme
  marginStyles: string
  actualDate: dayjs.Dayjs
  eventThisDay: (Appointment | Survey | Referral)[]
}

const DayBackground: React.FC<React.PropsWithChildren<DayBackground>> = ({
  theme,
  marginStyles,
  actualDate,
  eventThisDay,
}) => {
  const isPast = actualDate.isBefore(dayjs().startOf('day'))

  if (!eventThisDay.length) {
    return <></>
  }

  const getBgColor = (treatmentItem: Appointment | Survey | Referral) => {
    if (treatmentItem.__typename === 'Appointment') {
      return isPast
        ? theme.palette.grey[100]
        : treatmentItem.status === AppointmentStatus.BetmenBooked ||
            treatmentItem.status === AppointmentStatus.EesztBooked
          ? theme.palette.success.light
          : theme.palette.primary.light
    }
    return isPast ? theme.palette.grey[100] : theme.palette.success.dark
  }

  return (
    <Box
      position="absolute"
      display="flex"
      flexDirection="column"
      top={1}
      bottom={1}
      left={1}
      right={1}
      zIndex={0}
    >
      {eventThisDay.map((el, index) => (
        <Box
          key={index}
          className={marginStyles}
          flexGrow={1}
          data-cy={`DayBackground-Box-${el.id}`}
          bgcolor={getBgColor(el)}
        />
      ))}
    </Box>
  )
}

export { DayBackground }
